import { IconProps } from "../../utils/global-types/global-types";

// `solid` paints the mark in currentColor (e.g. white) instead of the brand gradient — used on
// the blue assistant avatar where the gradient fill would otherwise blend into the background.
const VfCopilotIcon = ({ className, solid = false, ...rest }: IconProps & { solid?: boolean }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    className={className ? className : "w-[18px] h-[18px]"}
    {...rest}
  >
    <path
      fill={solid ? "currentColor" : "url(#paint0_linear_24062_223807)"}
      fillRule="evenodd"
      d="M8.975 3.778a1 1 0 0 0-1.95 0l-.553 2.433a3 3 0 0 1-2.26 2.26l-2.434.554a1 1 0 0 0 0 1.95l2.433.553a3 3 0 0 1 2.26 2.26l.554 2.434a1 1 0 0 0 1.95 0l.553-2.433a3 3 0 0 1 2.26-2.26l2.434-.554a1 1 0 0 0 0-1.95l-2.433-.553a3 3 0 0 1-2.26-2.26z"
      clipRule="evenodd"
    ></path>
    <path
      fill={solid ? "currentColor" : "url(#paint1_linear_24062_223807)"}
      fillRule="evenodd"
      d="M14.418 1.334a.429.429 0 0 0-.836 0l-.237 1.042c-.11.483-.486.86-.969.969l-1.042.237a.429.429 0 0 0 0 .836l1.042.237c.483.11.86.486.969.969l.237 1.042a.429.429 0 0 0 .836 0l.237-1.042c.11-.483.486-.86.969-.969l1.042-.237a.429.429 0 0 0 0-.836l-1.042-.237a1.29 1.29 0 0 1-.969-.969z"
      clipRule="evenodd"
    ></path>
    <defs>
      <linearGradient
        id="paint0_linear_24062_223807"
        x1="0.738"
        x2="16.167"
        y1="18.167"
        y2="17.465"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#98D9D9"></stop>
        <stop offset="0.486" stopColor="#4CA5FF"></stop>
        <stop offset="1" stopColor="#9A78B8"></stop>
      </linearGradient>
      <linearGradient
        id="paint1_linear_24062_223807"
        x1="10.571"
        x2="17.321"
        y1="7"
        y2="1.813"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5D78B5" stopOpacity="0"></stop>
        <stop offset="0.514" stopColor="#4CA5FF" stopOpacity="0.4"></stop>
        <stop offset="1" stopColor="#2F5691"></stop>
      </linearGradient>
    </defs>
  </svg>
);

export default VfCopilotIcon;
